export interface SongNote {
  note: string; // Note ID (e.g., "C4")
  time: number; // Time in seconds from start
  duration?: number; // Optional visual duration
  velocity?: number; // 0-127, defaults to 100
}

export interface Song {
  id: string;
  title: string;
  notes: SongNote[];
}

export const SONGS: Song[] = [
  {
    id: "twinkle",
    title: "Twinkle Twinkle Little Star",
    notes: [
      // "Twin-kle Twin-kle" (0.6s steps)
      { note: "C4", time: 0.0 }, { note: "C3", time: 0.0 },
      { note: "C4", time: 0.6 },
      { note: "G4", time: 1.2 },
      { note: "G4", time: 1.8 },

      // "Lit-tle"
      { note: "A4", time: 2.4 }, { note: "F3", time: 2.4 }, // Bass note F
      { note: "A4", time: 3.0 },

      // "Star" (Hold for 1.2s)
      { note: "G4", time: 3.6 }, { note: "C3", time: 3.6 }, // Bass note C

      // "How I Won-der"
      { note: "F4", time: 4.8 }, { note: "F3", time: 4.8 },
      { note: "F4", time: 5.4 },
      { note: "E4", time: 6.0 },
      { note: "E4", time: 6.6 },

      // "What you"
      { note: "D4", time: 7.2 },
      { note: "D4", time: 7.8 },

      // "Are" (Hold for 1.2s)
      { note: "C4", time: 8.4 }, { note: "C3", time: 8.4 },
    ]
  },
  {
    id: "avatar",
    title: "Avatar's Love",
    notes: [
      // Measure 1: C Major (C - G - E)
      { note: "C4", time: 0.0 }, { note: "C5", time: 0.0 }, // Chord impact
      { note: "G4", time: 0.44 },
      { note: "E4", time: 0.88 },
      { note: "C4", time: 1.32 }, // Loop point

      // Measure 2: G Major Transition
      { note: "B4", time: 1.76 },
      { note: "G4", time: 2.20 },
      { note: "E4", time: 2.64 },
      { note: "A3", time: 3.08 }, // Root change to Am

      // Measure 3: A Minor
      { note: "A3", time: 3.52 }, { note: "A4", time: 3.52 }, // Chord
      { note: "G4", time: 3.96 },
      { note: "E4", time: 4.40 },
      { note: "A3", time: 4.84 },

      // Measure 4: F Major Transition
      { note: "F4", time: 5.28 },
      { note: "G4", time: 5.72 },
      { note: "E4", time: 6.16 },
      { note: "C4", time: 6.60 }, // Return to start/resolve
    ]
  },
];
